// Libs
import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import { ListingCard, Emoji } from "shared_components";
import { browserHistory } from "react-router";
import { useTranslation } from "react-i18next";

// Actions
import { fetchDropshipperData } from "../../../actions/settings";

// Components
import InfiniteScroll from "react-infinite-scroller";
import BestSelling from "../../component/BestSelling";
import { Tooltip, Tag } from "../../spocketUI";

function ListingCards({
  fetchDropshipperData,
  listings,
  recreateInfiniteScroll,
  appendNextPage,
  resetPageKey
}) {
  const { t, i18n } = useTranslation();

  /**
   * @param  { String } supplierShopName
   * @returns Function
   */
  const goToSupplierPage = supplierShopName => {
    return browserHistory.push(`/suppliers/${supplierShopName}`);
  };

  const renderTopSupplierTag = () => {
    return (
      <Tooltip
        width={180}
        message={t("ListingCards.TopSupplierTag.Tooltip")}
        position="top-right"
      >
        <Tag size="small">
          <Emoji label="Diamond Emoji" symbol="💎" />{" "}{t("ListingCards.TopSupplierTag.Text")}
        </Tag>
      </Tooltip>
    );
  };

  return (
    // TODO - Pagination
    <div
      key={resetPageKey}
      id="searchProductSection"
      style={{ marginBottom: "98px" }}
    >
      <InfiniteScroll
        pageStart={1}
        loadMore={appendNextPage}
        hasMore={!listings.isFetching && listings.hasMore}
        threshold={100}
        loader={
          <div className="loader" key={0}>
            .
          </div>
        }
        initialLoad={false}
      >
        <div style={{ display: "flex", flexWrap: "wrap", margin: "0 -16px" }}>
          {listings.products.map((product, index) => {
            const { id, supplier_shop_name, best_selling } = product;

            return (
              <Col xs={12} sm={6} md={4} lg={3} key={id}>
                <ListingCard
                  key={id}
                  listing={product}
                  listingIndex={index}
                  shouldDisplayImportBtn
                  bestSelling={best_selling ? <BestSelling t={t} /> : null }
                  openSupplierLandingPage={() =>
                    goToSupplierPage(supplier_shop_name)
                  }
                  fetchDropshipperData={fetchDropshipperData}
                  topSupplier={renderTopSupplierTag()}
                  t={t}
                  i18n={i18n}
                />
              </Col>
            );
          })}
        </div>
      </InfiniteScroll>
    </div>
  );
}

ListingCards.propTypes = {
  fetchDropshipperData: PropTypes.func.isRequired,
  listings: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchDropshipperData }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(ListingCards);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/ListingCards.js